<template>
  <div>
    <!-- Dialog para filtrar impresion -->
    <v-dialog v-model="filtroImprimir" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Imprimir varios</v-card-title>
        <v-card-text>
          Indica el rango de fechas que quieres imprimir
        </v-card-text>
        <!-- Desde-->
        <v-card-text>
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFormattedDesde"
                label="Desde"
                persistent-hint
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_desde"
              no-title
              @input="menu1 = false"
              @change="changeDate($event)"
            ></v-date-picker>
          </v-menu>
        </v-card-text>
        <!-- Hasta-->
        <v-card-text>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFormattedHasta"
                label="Hasta"
                persistent-hint
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_hasta"
              no-title
              @input="menu2 = false"
              @change="changeDateHasta($event)"
            ></v-date-picker>
          </v-menu>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="filtroImprimir = false"
            class="ma-2"
            tile
            outlined
            color="error"
            text="text"
            >Cancelar</v-btn
          >
          <v-btn
            @click="preImpresion()"
            class="ma-2"
            tile
            outlined
            color="success"
            text="text"
            >Imprimir</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Imprimir comprobante -->
    <Imprimir :imprimir="imprimir" ref="imprimir" />
  </div>
</template>
<script>
import moment from "moment";
import Imprimir from "./../base/Imprimir";

export default {
  data() {
    return {
      filtroImprimir: false,
      date_desde: new Date().toISOString().substr(0, 10),
      date_hasta: new Date().toISOString().substr(0, 10),
      dateFormattedDesde: moment.utc(new Date()).format("L"),
      dateFormattedHasta: moment.utc(new Date()).format("L"),
      menu1: false,
      menu2: false,
      imprimir: [],
    };
  },
  created() {
    moment.locale("es");
  },
  components: { Imprimir },
  props: ["pedidos"],
  methods: {
    changeDate($event) {
      this.dateFormattedDesde = moment($event).format("L");
    },
    changeDateHasta($event) {
      this.dateFormattedHasta = moment($event).format("L");
    },
    async preImpresion() {
      this.$refs.imprimir.dialog = true;
      let desde = moment(this.dateFormattedDesde, "L")
        .subtract(1, "days")
        .format();
      let hasta = moment(this.dateFormattedHasta, "L")
        .add(1, "days")
        .format();

      this.imprimir = [];
      this.pedidos.forEach((element) => {
        let create = moment(element.entregaAt, "L").format();
        let validDate = moment(create).isBetween(desde, hasta);

        if (validDate) {
          this.imprimir.push({
            tipo_comprobante: element.tipo_comprobante,
            serie_comprobante: element.serie_comprobante,
            num_comprobante: element.num_comprobante,
            fecha: element.entregaAt,
            persona: element.persona,
            detalles: element.detalles,
            total: element.total,
          });
        }
      });

      await this.imprimir;
      this.filtroImprimir = false;
      this.$refs.imprimir.llamarCliente();
    },
  },
};
</script>
